import * as yup from 'yup';
import i18n from 'i18next';

const userFormSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required(() => i18n.t('common.message.requiredField')),
  email: yup
    .string()
    .email()
    .trim()
    .required(() => i18n.t('common.message.requiredField')),
  description: yup.string(),
});

export default userFormSchema;
